import React from 'react';

function SearchIcon(props) {

  const {
    className,
    ...otherProps
  } = props;

  return (
    <svg width='19px' height='18px' viewBox='0 0 19 18' version='1.1' xmlns='http://www.w3.org/2000/svg' className={`search-svg-icon ${className}`} {...otherProps}>
      <g id="2048---Search-Update" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="2048---Search-Update-1" transform="translate(-103.000000, -28.000000)" fill="#151921">
          <g id="Dash*" transform="translate(102.000000, -1.000000)">
              <g id="Group-7">
                  <path d="M14.6759414,31.3161415 C11.5518436,28.2279528 6.46823971,28.2279528 3.3430734,31.3161415 C0.218975532,34.4053864 0.218975532,39.430558 3.3430734,42.5187467 C5.97889743,45.1232177 10.0026158,45.5224432 13.073292,43.7343778 L17.6985382,47 L19.2093023,45.5055448 L15.9057077,40.9345186 C17.7156331,37.8991375 17.310697,33.9216687 14.6759414,31.3161415 L14.6759414,31.3161415 Z M13.1651773,41.0253477 C10.8744571,43.2897377 7.14562618,43.2897377 4.85490599,41.0253477 C2.5641858,38.7609576 2.5641858,35.0749868 4.85490599,32.8105967 C7.14562618,30.5462067 10.8744571,30.5462067 13.1651773,32.8105967 C15.4569659,35.0749868 15.4569659,38.7609576 13.1651773,41.0253477 L13.1651773,41.0253477 Z" id="Icons/Search"></path>
              </g>
          </g>
      </g>
    </g>
    </svg>
  );
}

export default SearchIcon;



// WEBPACK FOOTER //
// ./shared/common/svgs/SearchIcon.js